import { AlunoCurso } from "../models";
import { turnosHorarios } from "./turnos-horarios";

export function alunoCursoTurnosHorarios(alunoCurso: Partial<AlunoCurso>) {
  let professor_temp = alunoCurso?.professor_temp;

  const data: { [key: string]: any } | undefined = alunoCurso?.data ? typeof alunoCurso?.data === "string" ? JSON.parse(alunoCurso?.data) : alunoCurso?.data : undefined;

  if (!professor_temp && data) {
    professor_temp = data?.professor_temp ?? data?.original_data?.professor_temp;
  }

  return turnosHorarios(professor_temp, alunoCurso?.dias_semana_temp);
}
